import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";
import { IExamMarks } from "./assessment";
import { useGetExamQuestions } from "./useGetExamQuestions";

export const useGetExamMarks = (assessmentId: string) => {
    const { user, siteId } = useAuth();
    const [getRecords] = useLazyReadMultipleQuery();
    const [examMarksId, setExamMarksId] = useState<IExamMarks[]>([]);
    const [questionsCount, setQuestionsCount] = useState(0);

    const { questions } = useGetExamQuestions(assessmentId);

    useEffect(() => {
        if (questions && questions.length > 0) {
            const questionIds = questions.map(q => q.questionId); 

            questionIds.forEach(questionId => {
                getExamMarks([questionId]); 
            });
        }
        // eslint-disable-next-line
    }, [questions]);

    const getExamMarks = async (questionIds: string[]): Promise<void> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.');
        }

        const questionIdFilters = questionIds.map((id) => ({
            field: "edtec365_questionmapping",
            type: FieldFilterType.Const,
            value: id
        }));

        try {
            const data = await getRecords({
                userId: user.contactId,
                portalId: siteId || '',
                tableId: "slcm_exammarks",
                fieldList: ["edtec365_questionmapping", "slcm_exammarksid"],
                filters: [{
                    group: 0,
                    filters: questionIdFilters
                }]
            }).unwrap();

            if (data.records.length === 0) {
                console.warn("No records found for the given question IDs.");
            }

            const questionsRecords = data.records.map(record => ({
                examMarksId: record["slcm_exammarksid"] as string,
                questionMappingId: record["edtec365_questionmapping"] as string,
            }));

            setExamMarksId(prev => [...prev, ...questionsRecords]);
            setQuestionsCount(prev => prev + questionsRecords.length);
        } catch (error) {
            console.error('Error fetching exam marks:', error);
        }
    };

    return { examMarksId, questionsCount, setExamMarksId };
};
